export default __webpack_public_path__ + "static/media/l.6b7278f1.mp3";